export default "__VITE_ASSET__mAgQZGW3__"